
<div class="flex flex-row justify-between">

  <div class="max-w-[139px]">
    <p v-if="product.classification !== 'transportation'" class="product-name">
      <a :href="`/products/${product.slug}`" class="hover:font-semibold transition-all">
        {{ product.name }}
      </a>
    </p>
    <p v-else class="product-name">
      {{ product.name }}
    </p>
  </div>

  <div class="flex items-center justify-center w-[134px]">
    <span v-if="product.classification !== 'transportation'">
      <quantity-control
        v-model="quantity"
        :minimum="0"
        :disabled="loading"
        class="is-small"
        @input="handleQuantityChange" 
      />
    </span>
    <div v-else class="order-item-quantity flex items-center justify-center">
      <p>{{ item.quantity }}</p>
    </div>
  </div>

  <div v-if="showPrice" class="flex items-center w-[79px]">
    <p class="price-txt">{{ dollars(item.priceCents) }}</p>
  </div>
</div>
